import { Financier, IActivityStreams, IDocument, PaymentAnalysis, PaymentPlan } from "../../resources/interfaces";
import { Company } from "../company/Company";
import { ICustomer } from "../customer/ICustomer";
import { Insurer } from "../insurer/Insurer";
import { IVehicle } from "../vehicle/IVehicle";
import { Vehicle } from "../vehicle/Vehicle";
import { IPremiumFinancing } from "./IPremiumFinancing";

export class PremiumFinancing {
  activityStreams: IActivityStreams[];
  applicationNumber:  number;
  approvedBy: string;
  approvedOn: string;
  countryId: number;
  createdOn: string;
  id: number;
  ownerConsent: boolean;
  repairCost: number;
  repairDescription: string;
  repairType: string;
  reviewStage: string;
  updatedOn: string;
  vehicles: Vehicle;
  customer: ICustomer;
  createdBy: string;
  financier: Financier;
  insurer: Insurer;
  broker: Company;
  paymentAnalysis: PaymentAnalysis;
  payments: any;
  plan: PaymentPlan;
  premium: number;
  protectionType: string;
  verifiedOn: string;
  ref: string;
  active: boolean;
  documents: IDocument[];
  customerName?: string;
  financierName?: string;
  insurerName?: string;


    constructor(Imodel:IPremiumFinancing){
        this.activityStreams = Imodel.activityStreams;
        this.applicationNumber = Imodel.applicationNumber;
        this.approvedBy = Imodel.approvedBy;
        this.approvedOn = Imodel.approvedOn;
        this.countryId = Imodel.countryId;
        this.createdOn = Imodel.createdOn;
        this.id = Imodel.id;
        this.ownerConsent = Imodel.ownerConsent;
        this.repairCost = Imodel.repairCost;
        this.repairDescription = Imodel.repairDescription;
        this.repairType = Imodel.repairType;
        this.reviewStage = Imodel.reviewStage;
        this.updatedOn = Imodel.updatedOn;
        this.vehicles = Imodel.vehicles;
        this.customer = Imodel.customer;
        this.createdBy = Imodel.createdBy;
        this.financier = Imodel.financier;
        this.insurer = Imodel.insurer;
        this.broker = Imodel.broker;
        this.paymentAnalysis = Imodel.paymentAnalysis;
        this.payments = Imodel.payments;
        this.plan = Imodel.plan;
        this.premium = Imodel.premium;
        this.protectionType = Imodel.protectionType;
        this.verifiedOn = Imodel.verifiedOn;
        this.ref = Imodel.ref;
        this.active = Imodel.active;
        this.documents = Imodel.documents;
        this.customerName = Imodel.customerName
        this.financierName = Imodel.financierName;
        this.insurerName = Imodel.insurerName;
    }
}